// Mascotti Pets — scripts propios (mt-*)
document.addEventListener('DOMContentLoaded', function () {
  initRevelado();
  initGaleriaProducto();
  initVariantesProducto();
  initCantidadProducto();
});

function initRevelado() {
  // El CSS deja todo visible por defecto (ver mt-styles.css). Solo si
  // podemos animar de verdad activamos la clase que oculta y anima la
  // entrada; si algo de esto no está disponible, no tocamos nada y el
  // contenido se queda tal cual, visible.
  if (typeof IntersectionObserver === 'undefined') return;
  var elementos = document.querySelectorAll('.mt-reveal, .mt-reveal-escalonado');
  if (!elementos.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.documentElement.classList.add('js-mt-reveal-activo');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  elementos.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-imagen-principal]');
    var miniaturas = galeria.querySelectorAll('[data-mt-miniatura]');
    if (!principal || !miniaturas.length) return;

    miniaturas.forEach(function (miniatura) {
      miniatura.addEventListener('click', function () {
        var nuevaSrc = miniatura.getAttribute('data-full');
        if (!nuevaSrc) return;
        principal.src = nuevaSrc;
        principal.srcset = '';
        miniaturas.forEach(function (m) { m.classList.remove('is-activa'); });
        miniatura.classList.add('is-activa');
      });
    });
  });
}

function initVariantesProducto() {
  var formularios = document.querySelectorAll('[data-mt-form-producto]');
  formularios.forEach(function (form) {
    var datosScript = form.querySelector('[data-mt-variantes-json]');
    if (!datosScript) return;

    var variantes;
    try {
      variantes = JSON.parse(datosScript.textContent);
    } catch (e) {
      return;
    }

    // El precio y su tachado viven FUERA del <form> (son hermanos, no hijos,
    // ver sections/mt-producto.liquid), así que buscamos en el contenedor
    // que envuelve tanto el precio como el formulario, no solo en el form.
    var contenedor = form.closest('.mt-producto__columna') || form;

    var inputId = form.querySelector('input[name="id"]');
    var botonAnadir = form.querySelector('[data-mt-anadir]');
    var precioActual = contenedor.querySelector('[data-mt-precio-actual]');
    var precioComparado = contenedor.querySelector('[data-mt-precio-comparado]');
    var selectores = form.querySelectorAll('[data-mt-opcion]');

    function variantePorSeleccion() {
      var seleccion = [];
      selectores.forEach(function (grupo) {
        var activo = grupo.querySelector('.is-seleccionada');
        if (activo) seleccion.push(activo.getAttribute('data-valor'));
      });
      return variantes.find(function (v) {
        return v.options.length === seleccion.length && v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
    }

    function formatoDinero(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      });
    }

    function actualizar() {
      var variante = variantePorSeleccion();
      if (!variante) {
        if (botonAnadir) {
          botonAnadir.disabled = true;
          botonAnadir.textContent = botonAnadir.getAttribute('data-texto-agotado') || botonAnadir.textContent;
        }
        return;
      }
      if (inputId) inputId.value = variante.id;
      if (precioActual) precioActual.textContent = formatoDinero(variante.price);
      if (precioComparado) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioComparado.textContent = formatoDinero(variante.compare_at_price);
          precioComparado.style.display = '';
        } else {
          precioComparado.style.display = 'none';
        }
      }
      if (botonAnadir) {
        if (variante.available) {
          botonAnadir.disabled = false;
          botonAnadir.textContent = botonAnadir.getAttribute('data-texto-disponible') || botonAnadir.textContent;
        } else {
          botonAnadir.disabled = true;
          botonAnadir.textContent = botonAnadir.getAttribute('data-texto-agotado') || 'Agotado';
        }
      }
    }

    selectores.forEach(function (grupo) {
      grupo.querySelectorAll('[data-valor]').forEach(function (boton) {
        boton.addEventListener('click', function () {
          grupo.querySelectorAll('[data-valor]').forEach(function (b) { b.classList.remove('is-seleccionada'); });
          boton.classList.add('is-seleccionada');
          actualizar();
        });
      });
    });

    actualizar();
  });
}

function initCantidadProducto() {
  document.querySelectorAll('[data-mt-cantidad]').forEach(function (envoltorio) {
    var input = envoltorio.querySelector('input');
    var menos = envoltorio.querySelector('[data-mt-restar]');
    var mas = envoltorio.querySelector('[data-mt-sumar]');
    if (!input) return;

    if (menos) {
      menos.addEventListener('click', function () {
        var valor = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = valor;
      });
    }
    if (mas) {
      mas.addEventListener('click', function () {
        var valor = (parseInt(input.value, 10) || 1) + 1;
        input.value = valor;
      });
    }
  });
}
